// Full-page host for the Data Assistant.
//
// This page renders no chat UI of its own. It registers its container with
// ChatUiContext, and the single ChatAssistant instance mounted in Header portals its
// body in here. Doing it that way means switching between docked and full page does
// not unmount the assistant, so the conversation and any in-progress import survive
// the switch.
import { Box } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useChatUi } from './ChatUiContext';

export default function AssistantPage() {
    const { mode, setMode, registerFullPageSlot } = useChatUi();

    // Callback ref so the slot is registered as soon as the node exists (and cleared
    // when it goes away), rather than one render later via useEffect.
    const slotRef = useCallback((node: HTMLDivElement | null) => {
        registerFullPageSlot(node);
    }, [registerFullPageSlot]);

    useEffect(() => () => registerFullPageSlot(null), [registerFullPageSlot]);

    // Landing here directly (deep link, refresh, bookmark) means the user wants the
    // full-page view, so make that the active mode.
    useEffect(() => {
        if (mode !== 'fullPage') setMode('fullPage');
    }, [mode, setMode]);

    return (
        <Box
            ref={slotRef}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                // main -> .main-outlet are both flex columns with flex-grow:1
                // (App.scss), so flexGrow alone fills the outlet. minHeight:0 lets the
                // message list scroll instead of stretching this container.
                minHeight: 0,
            }}
        />
    );
}
